import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FakeText, Typography } from '@totalsoft/rocket-ui';
import { Accordion, AccordionDetails, AccordionSummary, Grid, Tooltip, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import QuestionComponent from './QuestionListItemComponent';
import QuestionSummaryComponent from './QuestionSummaryComponent';
import { Delete, Save } from '@mui/icons-material';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const QuestionListComponent = ({
  questions,
  questionTypes,
  loading,
  onSave,
  validation,
  isReadOnly,
  onPropertyChanged,
  getIndexInFilteredList,
  onAddNewQuestionDetailRow,
  onDetailPropertyChanged,
  onDeleteQuestionDetailRow,
  onExpandChange,
  onDelete
}) => {
  const { t } = useTranslation();

  return questions.map((item, idx) => {
    const header = <QuestionSummaryComponent questions={item} />;
    const index = getIndexInFilteredList(idx);

    return (
      <Grid key={idx} item xs={12} sx={{ marginBottom: '35px!important' }}>
        <Accordion expanded={item.isExpanded} onChange={(_, isExpanded) => onExpandChange(isExpanded, index)}>
          <AccordionSummary sx={{ width: '100%' }} expandIcon={<ExpandMoreIcon />}>
            {(item.isExpanded || (!item.isExpanded && !header)) && (
              <Grid container spacing={1} justifyContent='flex-end' onClick={event => event.stopPropagation()}>
                <Grid item>
                  <Tooltip title={t('Questionnaire.SaveChanges')}>
                    <div>
                      <IconButton
                        color='primary'
                        onClick={onSave(index)}
                        disabled={isReadOnly || !item.changed || !(validation[index] |> isValid) || (validation |> getErrors) !== ''}
                      >
                        <Save />
                      </IconButton>
                    </div>
                  </Tooltip>
                </Grid>
                <Grid item>
                  <Tooltip title={t('Tooltips.Questionnaire.DeleteQuestion')}>
                    <IconButton color='primary' onClick={onDelete(index)} disabled={isReadOnly}>
                      <Delete />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            )}
            {!item.isExpanded && header}
          </AccordionSummary>
          <AccordionDetails>
            {loading ? (
              <FakeText lines={10} />
            ) : (
              <Grid container spacing={1}>
                <Grid container item xs={12} justifyContent='flex-end'>
                  <Typography color='error'>{validation |> getErrors}</Typography>
                </Grid>
                <QuestionComponent
                  question={item}
                  index={index}
                  questionTypes={questionTypes}
                  loading={loading}
                  onSave={onSave}
                  collectionValidation={validation}
                  isReadOnly={isReadOnly}
                  onPropertyChanged={onPropertyChanged}
                  onAddNewQuestionDetailRow={onAddNewQuestionDetailRow}
                  onDetailPropertyChanged={onDetailPropertyChanged}
                  onDeleteQuestionDetailRow={onDeleteQuestionDetailRow}
                />
              </Grid>
            )}
          </AccordionDetails>
        </Accordion>
      </Grid>
    );
  });
};

QuestionListComponent.propTypes = {
  questions: PropTypes.array.isRequired,
  questionTypes: PropTypes.array,
  loading: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool,
  onPropertyChanged: PropTypes.func.isRequired,
  getIndexInFilteredList: PropTypes.func.isRequired,
  onAddNewQuestionDetailRow: PropTypes.func.isRequired,
  onDetailPropertyChanged: PropTypes.func.isRequired,
  onDeleteQuestionDetailRow: PropTypes.func.isRequired,
  onExpandChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default QuestionListComponent;
